<template>
  <div>
    <Row>
      <Column :md="6">
        <Field
          autocomplete="given-name"
          data-cy="firstName"
          :label="$t('firstName')"
          required
          :value.sync="user.firstName" />
      </Column>
      <Column :md="6">
        <Field
          autocomplete="family-name"
          data-cy="lastName"
          :label="$t('lastName')"
          required
          :value.sync="user.lastName" />
      </Column>
    </Row>
    <Field
      autocomplete="email"
      :disabled="!['admin', 'signup'].includes(type)"
      :label="$t('email')"
      required
      rules="email"
      type="email"
      :value.sync="user.email" />
    <template v-if="type === 'admin'">
      <Row>
        <Column :md="6">
          <Field
            data-cy="role"
            :label="$t('role')"
            :options="roleOptions"
            type="select"
            :value.sync="user.role" />
        </Column>
      </Row>
    </template>
    <ValidationObserver v-if="canEditLogin || (type === 'edit' && hasPasswordChange)">
      <Field
        v-if="type === 'edit'"
        autocomplete="current-password"
        :label="$t('passwordCurrent')"
        :maxlength="64"
        :minlength="8"
        required
        rules="password"
        type="password"
        :value.sync="user.passwordCurrent" />
      <Row>
        <Column :lg="6">
          <Field
            autocomplete="current-password"
            :label="passwordLabel"
            :maxlength="64"
            :minlength="8"
            name="password"
            :required="type === 'signup'"
            rules="password|passwordNumber|passwordNotAllNumeric"
            type="password"
            :value.sync="user.password" />
        </Column>
        <Column :lg="6">
          <Field
            autocomplete="new-password"
            :label="`${passwordLabel} ${$t('again')}`"
            :required="type === 'signup'"
            rules="passwordMatch:password"
            type="password"
            :value.sync="user.passwordMatch" />
        </Column>
      </Row>
    </ValidationObserver>
    <Btn v-if="isAdmin && user.id && !isUserVerified" class="verify-user" @click="verifyUser">
      Verify user
    </Btn>
    <template v-else-if="type === 'signup'">
      <FieldConsent :value.sync="user.hasAcceptedPolicy" />
    </template>
  </div>
</template>

<script>
import { actions, getters } from '@utils'
import FieldConsent from '@components/fields/FieldConsent'
import Message from '@mixins/Message'

export default {
  mixins: [Message],
  components: { FieldConsent },
  props: {
    hasPasswordChange: Boolean,
    type: String,
    user: Object,
  },
  computed: {
    isAdmin() {
      return this.hasRole('>=ADMIN')
    },
    isUserVerified() {
      return (this.query('user', this.user.id) || {}).isVerified
    },
    canEditLogin() {
      return ['signup', 'admin'].includes(this.type)
    },
    passwordLabel() {
      return this.type === 'edit'
        ? this.$t('passwordNew')
        : this.$t('password')
    },
    ...getters('roleOptions'),
  },
  methods: {
    async verifyUser() {
      await this.PATCH_AUTHMANAGEMENT({
        id: this.user.id,
        verifyToken: null,
      })

      this.SUCCESS(this.$t('verifySuccess'))
    },
    ...actions('PATCH_AUTHMANAGEMENT'),
  },
}
</script>

<style lang="scss">
.FormUser {
  .verify-user {
    margin-bottom: 0.5rem;
  }
}
</style>

<i18n>
{
  "en": {
    "email": "Email",
    "role": "Role",
    "firstName": "First name",
    "lastName": "Last name",
    "country": "Country",
    "password": "Password",
    "passwordCurrent": "Current password",
    "passwordNew": "New password",
    "role": "Role",
    "again": "(again)",
    "verifySuccess": "User verified"
  }
}
</i18n>
